import { FC } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

import { Map, StatisticBento, DashboardPageContainer, CampaignStatistics } from '@carcareers/components';
import {
  usePostStatisticsQuery,
  useUserStatisticsQuery,
  useRooftopMapStatisticsQuery,
  useRooftopStatisticsQuery,
} from '@carcareers/store';

import { Statistic } from './Statistic';

export const DashboardStatistics: FC = () => {
  const { data: postStatistics, isLoading: isPostStatisticsLoading } = usePostStatisticsQuery();
  const { data: userStatistics, isLoading: isUserStatisticsLoading } = useUserStatisticsQuery();
  const { data: rooftopStatistics, isLoading: isRooftopStatisticsLoading } = useRooftopStatisticsQuery();
  const { data: rooftopMapData } = useRooftopMapStatisticsQuery();

  return (
    <DashboardPageContainer hideBreadcrumbs>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'space-between' }}>
        <Statistic
          title="Jobs Posted"
          data={postStatistics?.lastSixMonthsPosts.map((month) => month.count) ?? []}
          dataLabel="Jobs Posted"
          xAxisLabels={postStatistics?.lastSixMonthsPosts.map((month) => month.month) ?? []}
          totalValue={postStatistics?.totalPosts ?? 0}
          previousValue={postStatistics?.lastMonthPosts ?? 0}
          activeValue={postStatistics?.activePosts ?? 0}
          isLoading={isPostStatisticsLoading}
        />
        <Statistic
          title="Accounts Onboarded"
          data={userStatistics?.lastSixMonthsJobseekers.map((month) => month.count) ?? []}
          dataLabel="Jobseekers"
          xAxisLabels={userStatistics?.lastSixMonthsJobseekers.map((month) => month.month) ?? []}
          secondaryData={userStatistics?.lastSixMonthsEmployers.map((month) => month.count) ?? []}
          secondaryDataLabel="Employers"
          totalValue={userStatistics?.totalJobseekers ?? 0}
          previousValue={userStatistics?.lastMonthJobseekers ?? 0}
          activeValue={userStatistics?.activeJobseekers ?? 0}
          isLoading={isUserStatisticsLoading}
        />
        <Statistic
          title="Active Applicants"
          data={userStatistics?.lastSixMonthsUsers.map((month) => month.count) ?? []}
          dataLabel="Active Applicants"
          xAxisLabels={userStatistics?.lastSixMonthsUsers.map((month) => month.month) ?? []}
          totalValue={userStatistics?.totalUsers ?? 0}
          previousValue={userStatistics?.lastMonthUsers ?? 0}
          activeValue={userStatistics?.activeUsers ?? 0}
          isLoading={isUserStatisticsLoading}
        />
      </Box>
      <Card elevation={0} sx={{ width: '100%', borderRadius: 3, border: 0 }}>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Rooftops Onboarded
          </Typography>
          <StatisticBento
            allValue={rooftopStatistics?.totalRooftops ?? 0}
            previousValue={rooftopStatistics?.lastMonthRooftops ?? 0}
            activeValue={rooftopStatistics?.thisMonthRooftops ?? 0}
            isLoading={isRooftopStatisticsLoading}
            sx={{
              position: 'absolute',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              maxWidth: '500px',
              backgroundColor: 'secondary.main',
              borderRadius: '10px',
              zIndex: 1,
              padding: 1,
              margin: 1,
              color: 'secondary.contrastText',
            }}
          />
          <Map heatmapData={rooftopMapData || { type: 'FeatureCollection', features: [] }} />
        </CardContent>
      </Card>
      <CampaignStatistics />
    </DashboardPageContainer>
  );
};

export default DashboardStatistics;
